import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { UserInfoComponent } from './components/user-info/user-info.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { MenuComponent } from './components/menu/menu.component';
import { IonicModule } from '@ionic/angular';
import { ZXingScannerModule } from '@zxing/ngx-scanner';
import { ScannerComponent } from './components/scanner/scanner.component';
import { ScannerDialogComponent } from './components/scanner-dialog/scanner-dialog.component';
import { EditImageComponent } from './components/edit-image/edit-image.component';
import { MatDialogModule } from '@angular/material/dialog';
import { DesignSystemModule } from '@bcl/design-system';
import { CheckStockComponent } from './components/check-stock/check-stock.component';
import { ChatModule } from './components/chat';
import { ChatListComponent } from './components/chat-list/chat-list.component';
import { PipesModule } from '../pipes/pipes.module';

@NgModule({
  declarations: [
    UserInfoComponent,
    MenuComponent,
    ScannerComponent,
    ScannerDialogComponent,
    EditImageComponent,
    CheckStockComponent,
    ChatListComponent,
  ],
  imports: [
    CommonModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    IonicModule,
    ZXingScannerModule,
    MatDialogModule,
    DesignSystemModule,
    ChatModule,
    PipesModule,
  ],
  exports: [
    UserInfoComponent,
    MenuComponent,
    CheckStockComponent,
    ScannerDialogComponent,
    ScannerComponent,
    ChatModule,
    ChatListComponent,
    PipesModule,
  ],
})
export class SharedComponentsModule {}
